import { AccessibilityIcon } from '@acorns/grove/icons'
import styled from 'styled-components'

import { whiteIconStyle } from '../styled-components'

export const Container = styled.div`
  cursor: pointer;
  height: 24px;
`

export const WhiteAccessibilityIcon = styled(AccessibilityIcon)`
  ${whiteIconStyle}
`
